export default __webpack_public_path__ + "assets/9e221a34d9a91d024642cc33a3fecb98.png";